<template>
    <!-- 2 row -->
    <!-- <v-layout row wrap v-if="type_richmenu === 1">
      <v-layout row wrap>
        <v-col cols="4" v-for="(item, index) in list_menu" :key="index" class="d-flex pa-0">
          <v-img
            :src="item.picture"
            :lazy-src="item.picture"
            @click="sendrichmenu(item, index)"
            aspect-ratio="1.0"
            class="cursor"
          >
          </v-img>
        </v-col>
      </v-layout>
    </v-layout> -->

    <div class="rich-menu" v-if="type_richmenu === 1">
      <div class="menu-item cursor" v-for="(item, index) in list_menu" :key="index">
          <img :src="item.picture" @click="sendrichmenu(item, index)">
        </div>
    </div>

    <!-- <v-layout row wrap justify-center v-else-if="type_richmenu === 2">
      <v-layout row wrap>
        <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 lg6 xl6 class="pa-0">
          <v-card>
            <v-img
              cover
              class="cursor"
              :src="item.picture"
              :lazy-src="item.picture"
              aspect-ratio="1.5"
              min-height="100px"
              @click="sendrichmenu(item, index)"
            >
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout> -->

    <div class="rich-menu-2" v-else-if="type_richmenu === 2">
      <div class="menu-item-2 cursor" v-for="(item, index) in list_menu" :key="index">
          <img :src="item.picture" @click="sendrichmenu(item, index)">
        </div>
    </div>

    <!-- <v-layout row wrap justify-center v-else-if="type_richmenu === 3">
      <v-layout row wrap>
        <v-flex xs12 md12 sm12 lg12 xl12 class="pa-0">
          <v-card>
            <v-img
              contain
              class="cursor"
              :src="list_menu[0].picture"
              :lazy-src="list_menu[0].picture"
              aspect-ratio="1"
              height="100px"
              @click="sendrichmenu(list_menu[0], 0)"
            >
            </v-img>
          </v-card>
        </v-flex>
        <v-flex v-if="index !== 0" v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 lg4 xl4 class="pa-0">
          <v-card>
            <v-img
              cover
              class="cursor"
              :src="item.picture"
              :lazy-src="item.picture"
              aspect-ratio="1"
              height="100px"
              @click="sendrichmenu(item, index)"
            >
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout> -->
    <div class="photo-grid" v-else-if="type_richmenu === 3">
      <div class="photo-large large-photo cursor"><img :src="list_menu[0].picture" @click="sendrichmenu(list_menu[0], 0)" alt="Large"></div>
      <div class="photo small-photo cursor" v-if="index !== 0" v-for="(item, index) in list_menu" :key="index"><img :src="item.picture" @click="sendrichmenu(item, index)" alt="Small 1"></div>
    </div>

    <!-- <v-row v-else-if="type_richmenu === 3" class="justify-center">
      <v-col cols="10">
        <v-card
          class="pa-2"
          outlined
          tile
        >
        <img :src="list_menu[0].picture" @click="sendrichmenu(list_menu[0], 0)" alt="Large" width="375px"  height="125px">
        </v-card>
        <v-row no-gutters>
          <v-col
            cols="4"
            v-if="index !== 0" v-for="(item, index) in list_menu"
            :key="index"
          >
            <v-card
              class="pa-2"
              outlined
              style="background-color: lightgrey;"
              tile
            >
            <img :src="item.picture" @click="sendrichmenu(item, index)" alt="Small 1" width="50%">
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->


    <v-layout row wrap justify-center v-else-if="type_richmenu === 4">
      <v-layout row wrap>
        <v-flex xs8 md8 sm8 lg8 xl8 class="pa-0">
          <v-card>
            <v-img
              cover
              class="cursor"
              :src="list_menu[0].picture"
              :lazy-src="list_menu[0].picture"
              aspect-ratio="1"
              min-height="170px"
              @click="sendrichmenu(list_menu[0], 0)"
            >
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs4 md4 sm4 lg4 xl4 class="pa-0">
          <v-card>
            <v-layout column>
              <v-flex v-if="index !== 0" v-for="(item, index) in list_menu" :key="index" xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
                <v-card>
                  <v-img
                    cover
                    class="cursor"
                    min-height="85px"
                    :src="item.picture"
                    :lazy-src="item.picture"
                    aspect-ratio="1"
                    @click="sendrichmenu(item, index)"
                  >
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-layout row wrap justify-center v-else-if="type_richmenu === 5">
      <v-layout row wrap>
        <v-flex v-for="(item, index) in list_menu" :key="index" xs12 md12 sm12 lg12 xl12 class="pa-0">
          <v-card>
            <v-img
              cover
              class="cursor"
              height="90px"
              :src="item.picture"
              :lazy-src="item.picture"
              aspect-ratio="3"
              @click="sendrichmenu(item, index)"
            >
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <!-- <v-layout row wrap justify-start v-else-if="type_richmenu === 6">
      <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 lg6 xl6 class="pa-0">
        <v-card>
          <v-img
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            min-height="180px"
            aspect-ratio="1.3"
            cover
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout> -->
    <div class="rich-menu-6" v-else-if="type_richmenu === 6">
      <div class="menu-item-6 cursor" v-for="(item, index) in list_menu" :key="index">
          <img :src="item.picture" @click="sendrichmenu(item, index)">
        </div>
    </div>

    <v-layout row wrap justify-center v-else-if="type_richmenu === 7">
      <v-flex xs12 md12 sm12 lg12 xl12 class="pa-0">
        <v-card>
          <v-img
            fill-height
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="1.5"
            height="260px"
            @click="sendrichmenu(list_menu[0], 0)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <div class="photo-grid" v-else-if="type_richmenu === 7">
      <div class="photo-large large-photo cursor"><img :src="list_menu[0].picture" @click="sendrichmenu(list_menu[0], 0)" alt="Large"></div>
    </div> -->

    <!-- 1 row -->
    <v-layout row wrap justify-center v-else-if="type_richmenu === 8">
      <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 lg4 xl4 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1"
            min-height="90px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center v-else-if="type_richmenu === 9">
      <v-flex xs4 md4 sm4 lg4 xl4 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="1"
            min-height="90px"
            @click="sendrichmenu(list_menu[0], 0)"
          >
          </v-img>
        </v-card>
      </v-flex>
      <v-flex xs8 md8 sm8 lg8 xl8 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[1].picture"
            :lazy-src="list_menu[1].picture"
            aspect-ratio="2"
            min-height="90px"
            @click="sendrichmenu(list_menu[1], 1)"
            >
          </v-img>
        </v-card>
      </v-flex>
  
    </v-layout>
    <v-layout row wrap justify-center v-else-if="type_richmenu === 10">
      <v-flex xs8 md8 sm8 lg8 xl8 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="2"
            min-height="90px"
            @click="sendrichmenu(list_menu[0], 0)"
            >
          </v-img>
        </v-card>
      </v-flex>
      <v-flex xs4 md4 sm4 lg4 xl4 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[1].picture"
            :lazy-src="list_menu[1].picture"
            aspect-ratio="1"
            min-height="90px"
            @click="sendrichmenu(list_menu[1], 1)"
            >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center v-else-if="type_richmenu === 11">
      <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 lg6 xl6 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1.5"
            min-height="90px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center v-else-if="type_richmenu === 12">
      <v-flex xs12 md12 sm12 lg12 xl12 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="3"
            height="70%"
            @click="sendrichmenu(list_menu[0], 0)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
      <v-layout row wrap justify-center v-else-if="type_richmenu === 13">
      <v-flex v-for="(item, index) in list_menu" :key="index" xs3 md3 sm3 lg3 xl3 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1.5"
            min-height="90px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </template>
  
  <script>
  export default {
    props: {
      Richmenudialog: false,
      inforrichmenu: {},
      type_richmenu: Number
    },
    data () {
      return {
        // type_richmenu: '12'
      }
    },
    created () {
      // console.log(this.inforrichmenu)
      // console.log(this.type_richmenu)
      this.list_menu = this.inforrichmenu
      // console.log(this.list_menu)
    },
    methods: {
      sendrichmenu (item, index) {
        // console.log(item)
        this.$emit('emitrichmenu', this.inforrichmenu[index])
      }
    },
    watch: {
      Richmenudialog () {
        if (this.Richmenudialog) {
          this.list_menu = this.inforrichmenu
        }
      }
    }
  }
  </script>
  
  <style lang="css" scoped>

.rich-menu {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 คอลัมน์ */
  gap: 0px; /* ช่องว่างระหว่างแต่ละช่อง */
  width: 100%;
  max-width: 320px;
  margin: 0px auto;
}

.rich-menu-2 {
  display: grid;
  /* grid-template-columns: repeat(2, 1fr); */
  grid-template-columns: 130px 130px;
  gap: 0px; /* ช่องว่างระหว่างแต่ละช่อง */
  width: 100%;
  /* max-width: 170px; */
  margin: 0px auto;
  justify-content: center;
}

.rich-menu-6 {
  display: grid;
  /* grid-template-columns: repeat(2, 1fr); */
  grid-template-columns: 180px 180px;
  gap: 0px; /* ช่องว่างระหว่างแต่ละช่อง */
  width: 100%;
  /* max-width: 170px; */
  margin: 0px auto;
  justify-content: center;
}

.rich-menu-3 {
  /* display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0px;
  width: 100%;
  margin: 0px auto;
  justify-content: center; */
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 คอลัมน์ */
  gap: 0px;
}

.menu-item {
  background-color: lightgray; /* พื้นหลังของแต่ละช่อง */
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1; /* ทำให้แต่ละช่องเป็นสี่เหลี่ยมจัตุรัส */
  border-radius: 0px; /* มุมโค้ง */
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
  overflow: hidden; /* ซ่อนส่วนที่เกินขอบ */
}

.menu-item-2 {
  background-color: lightgray; /* พื้นหลังของแต่ละช่อง */
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1; /* ทำให้แต่ละช่องเป็นสี่เหลี่ยมจัตุรัส */
  border-radius: 0px; /* มุมโค้ง */
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
  overflow: hidden; /* ซ่อนส่วนที่เกินขอบ */
  widows: 130px;
}

.menu-item-6 {
  background-color: lightgray; /* พื้นหลังของแต่ละช่อง */
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1; /* ทำให้แต่ละช่องเป็นสี่เหลี่ยมจัตุรัส */
  border-radius: 0px; /* มุมโค้ง */
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
  overflow: hidden; /* ซ่อนส่วนที่เกินขอบ */
  widows: 130px;
}

.menu-item-3 {
  background-color: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  border-radius: 0px; 
  overflow: hidden;
  widows: 130px;
  /* background-color: lightgray;
  text-align: center;
  padding: 20px;
  border-radius: 8px; */
}
.menu-item img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  /* object-fit: contain; ทำให้รูปภาพพอดีในช่อง */
  object-position: center; /* จัดให้อยู่ตรงกลาง */
}

.menu-item-2 img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  /* object-fit: contain; ทำให้รูปภาพพอดีในช่อง */
  object-position: center; /* จัดให้อยู่ตรงกลาง */
}

.menu-item-6 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* object-fit: contain; ทำให้รูปภาพพอดีในช่อง */
  object-position: center; /* จัดให้อยู่ตรงกลาง */
}
.menu-item-3 img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  /* object-fit: contain; ทำให้รูปภาพพอดีในช่อง */
  object-position: center; /* จัดให้อยู่ตรงกลาง */
}

.item-header {
  grid-column: span 3; /* ช่องนี้ครอบ 3 คอลัมน์ (เต็มแถวแรก) */
  /* background-color: rgb(255, 255, 255); */
  text-align: center;
  padding: 0px;
  border-radius: 0px;
}

.item-header img {
  width: 100%;
  height: 20%;
  object-fit: fill;
  /* object-fit: contain; ทำให้รูปภาพพอดีในช่อง */
  object-position: center; /* จัดให้อยู่ตรงกลาง */
}

.container {
  width: 100px; /* adjust to container size as needed */
  height: 100px; /* adjust to container size as needed */
}

.container img {
  max-width: 100%;
  max-height: 100%;
  display: block;
}

.photo-grid {
  display: grid;
  grid-template-rows: auto auto; /* แถวแบ่งเป็น 2: ใหญ่กับเล็ก */
  grid-template-columns: repeat(3, 1fr); /* 3 คอลัมน์ */
  gap: 0px; /* ระยะห่างระหว่างรูป */
}

.large-photo {
  grid-column: span 3; /* ครอบพื้นที่ทั้ง 3 คอลัมน์ */
}

.small-photo {
  aspect-ratio: auto; /* ให้รูปด้านล่างเป็นจัตุรัส */
  background-color: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  /* aspect-ratio: 1; */
  border-radius: 0px; 
  overflow: hidden;
  widows: 100%;
}

.photo img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* ให้รูปพอดีช่องโดยไม่บีบ */
  border-radius: 0px; /* มุมโค้งเล็กน้อย */
}

.photo-large img {
  width: 100%;
  height: 180px;
  object-fit: cover; /* ให้รูปพอดีช่องโดยไม่บีบ */
  border-radius: 0px; /* มุมโค้งเล็กน้อย */
  border-radius: 0px;
  object-position: center;
}

@media (max-width: 900px) {
  /* .photo-grid {
    grid-template-columns: 1fr;
  } */

  .photo-large img {
    width: 100%;
    height: 140px;
    object-fit: cover; /* ให้รูปพอดีช่องโดยไม่บีบ */
    border-radius: 0px; /* มุมโค้งเล็กน้อย */
    border-radius: 0px;
    object-position: center;
  }
  .photo img {
    width: 100%;
    height: 140px;
    object-fit: cover; /* ให้รูปพอดีช่องโดยไม่บีบ */
    border-radius: 0px; /* มุมโค้งเล็กน้อย */
    border-radius: 0px;
    object-position: center;
  }

  /* .small-photo {
    aspect-ratio: auto;
  } */
}

  /* >>>.v-responsive .v-image {
    height: 100% !important;
  } */
  /* >>>.v-image__image--cover {
    background-size: contain !important;
  } */
  >>>.v-sheet.v-card {
    border-radius: 0px !important;
  }
  .cursor {
    cursor: pointer;
  }
  >>>.v-card__text {
    padding: 10px;
    width: 100%;
  }
  >>>.v-card {
    display: block;
    border-radius: 2px;
    min-width: 0;
    position: relative;
    text-decoration: none;
    transition: .3s cubic-bezier(.25,.8,.5,1) !important;
    box-shadow: none !important;
  }
  >>>.mx-auto .v-card .theme--dark {
    box-shadow: none !important;
  }
  </style>
  